import { EventEmitter, Injectable, Input, Output } from "@angular/core";
import { MixinInjectorConstructor } from "./mixin";

export const PlaceholderMixin = <CLAZZ extends MixinInjectorConstructor>(Clazz: CLAZZ) => {
  @Injectable()
  abstract class Placeholder extends Clazz {
    @Input()
    placeholderLength!: number;

    @Output()
    public placeholderLengthChange = new EventEmitter<boolean>();
  }

  return Placeholder;
};

export const PlaceholderMixinInputs = ["placeholder"];
